// =============================================================================
// ConquistasView.ts — Conquistas e Arquivos (issue #122): a tela única que
// reúne os menus "entre uma eleição e outra" em abas — Diário Oficial (#99),
// Arquivos da CPI (#95) e Gabinete da Campanha (#94). Abre da tela inicial
// (opção visível quando logado); cada aba delega pra view original.
// =============================================================================
import { audio } from '../AudioEngine';
import { $, showScreen } from './dom';
import type { DiarioView } from './DiarioView';
import type { ArquivoView } from './ArquivoView';
import type { GabineteView } from './GabineteView';

export type ConquistasTab = 'diario' | 'arquivo' | 'gabinete';

const TABS: ConquistasTab[] = ['diario', 'arquivo', 'gabinete'];

export class ConquistasView {
  constructor(
    private readonly panes: { diario: DiarioView; arquivo: ArquivoView; gabinete: GabineteView },
    onBack: () => void,
  ) {
    $('btn-conquistas-back').onclick = () => {
      audio.sfx.urnaKey();
      onBack();
    };
    for (const tab of TABS) {
      $(`tab-btn-${tab}`).onclick = () => {
        audio.sfx.urnaKey();
        this.setTab(tab);
      };
    }
  }

  show(tab: ConquistasTab = 'diario'): void {
    showScreen('conquistas');
    this.setTab(tab);
  }

  private setTab(tab: ConquistasTab): void {
    for (const t of TABS) {
      $(`tab-btn-${t}`).classList.toggle('sel', t === tab);
      $(`tab-${t}`).style.display = t === tab ? '' : 'none';
    }
    this.panes[tab].show(); // cada aba recarrega o próprio acervo ao abrir
  }
}
